<template>
  	<div><!--class="public"-->
    	<slot />
  	</div>
</template>
<script>
	import Header from "@/components/Header";
	import Footer from "@/components/Footer";
	export default {
	  	name: "LayoutBasic",
	  	components: {
		    Header,
		    Footer
	  	}
	};
</script>
